export default __webpack_public_path__ + "static/media/victory-facts.bf0812f1.svg";